import ManageSensor from "./ManageSensor/ManageSensor";

const TemperatureSensorDetails = () => {
  return <ManageSensor />;
};

export default TemperatureSensorDetails;
